import { type Row, number, text } from './inventoryValues';

/** Tableau ATTR ignores nulls and displays * when the mark contains distinct known values. */
export function sourceAttr(values: ReadonlyArray<unknown>): unknown {
  const known = [...new Set(values.filter((value) => value !== null && value !== undefined))];
  return known.length === 1 ? known[0] : known.length ? '*' : null;
}

export function allocationMarks(rows: ReadonlyArray<Row>, dates: ReadonlyArray<string>) {
  return [...new Set(rows.map((row) => text(row.blackout)))].sort().map((blackout) => ({
    blackout,
    values: dates.map((date) => {
      const mark = rows.find(
        (row) => text(row.availability_day_of_week).slice(0, 10) === date && text(row.blackout) === blackout,
      );
      return mark ? number(mark.allocated_adjusted) : null;
    }),
  }));
}

// Original calendar-prct custom palette, reversed: low values green and high values red.
const PERCENT_PALETTE = [
  '#ed3b3d',
  '#eb4a4c',
  '#e9595b',
  '#e7696a',
  '#e57779',
  '#e38687',
  '#e29495',
  '#e0a3a3',
  '#deb0b1',
  '#dcbebe',
  '#dacbcc',
  '#d9d9d9',
  '#c7d3ca',
  '#b6cdbc',
  '#a5c7ae',
  '#95c1a1',
  '#86bb94',
  '#78b688',
  '#6ab07c',
  '#5daa71',
  '#50a467',
  '#459e5c',
  '#3a9953',
].reverse();
export function calendarColor(value: number | null, metric: string, maximum: number, ordinary: ReadonlyArray<string>) {
  if (value === null) return undefined;
  const fixed = metric === 'booked_rate_calendar' || metric === 'missed_rm_score';
  const input = metric === 'booked_rate_calendar' ? value * 100 : value;
  const palette = fixed ? PERCENT_PALETTE : ordinary;
  const limit = fixed ? 100 : maximum;
  const fraction = limit > 0 ? Math.max(0, Math.min(1, input / limit)) : 0;
  const position = fraction * (palette.length - 1),
    lower = Math.floor(position),
    upper = Math.ceil(position);
  const channels = (input: string) => {
    const color = /^#[0-9a-f]{3}$/i.test(input)
      ? '#' +
        input
          .slice(1)
          .split('')
          .map((value) => value + value)
          .join('')
      : input;
    return /^#[0-9a-f]{6}$/i.test(color)
      ? [1, 3, 5].map((offset) => parseInt(color.slice(offset, offset + 2), 16))
      : null;
  };
  const from = channels(palette[lower]),
    to = channels(palette[upper]);
  if (!from || !to) return palette[Math.round(position)];
  return (
    '#' +
    from
      .map((value, index) =>
        Math.round(value + (to[index] - value) * (position - lower))
          .toString(16)
          .padStart(2, '0'),
      )
      .join('')
  );
}
